import {SupportiveMedicationDrawer} from '@/modules/drug-catalog/supportive-medications/components/supportive-medication-drawer/supportive-medication-drawer'
import {drawer} from '@cypro/ui/components'
import {SupportiveMedicationDrugProvider} from '@/shared/contexts/supportive-medication-drug'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getSupportiveMedicationDrawerId(supportiveMedicationId: string) {
  return `supportive-medication-drawer-${supportiveMedicationId}`
}

export function openSupportiveMedicationDrawer(supportiveMedication: DrugCatalogItem) {
  const id = getSupportiveMedicationDrawerId(supportiveMedication.id)
  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {supportiveMedication && (
          <SupportiveMedicationDrugProvider supportiveMedicationDrug={supportiveMedication}>
            <SupportiveMedicationDrawer />
          </SupportiveMedicationDrugProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'supportive-medication-drawer',
    },
    size: 'lg',
  })
}
